import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import { CALENDAR_MODE_STORAGE_KEY, CalendarMode, DEFAULT_CALENDAR_MODE, isCalendarMode } from '@/helpers/calendarMode';
import CalendarModeContext, { CalendarModeContextValue } from './CalendarModeContext';

const readStoredMode = (): CalendarMode => {
  try {
    const stored = localStorage.getItem(CALENDAR_MODE_STORAGE_KEY);
    if (isCalendarMode(stored)) return stored;
    return DEFAULT_CALENDAR_MODE;
  } catch {
    return DEFAULT_CALENDAR_MODE;
  }
};

const CalendarModeProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [mode, setModeState] = useState<CalendarMode>(readStoredMode);

  const setMode = useCallback((next: CalendarMode) => {
    setModeState(next);
    try {
      localStorage.setItem(CALENDAR_MODE_STORAGE_KEY, next);
    } catch {
      // Private-mode / quota failures must not break the board.
    }
  }, []);

  const value = useMemo<CalendarModeContextValue>(() => [mode, setMode], [mode, setMode]);

  return <CalendarModeContext.Provider value={value}>{children}</CalendarModeContext.Provider>;
};

export default CalendarModeProvider;
